import {Input, Modal} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {CHANGE_CONTENT_FONT, CHANGE_HEADER_FONT} from "../store";

interface IProps {
    Visible: boolean
    CloseModal: () => void
}

interface IState {
    displayReducer: {
        ContentFontSize: number;
        HeaderFontSize: number;
    }
}

export default function FontsModal(props: IProps) {
    const contentFontSize = useSelector((state: IState) => state.displayReducer.ContentFontSize);
    const headerFontSize = useSelector((state: IState) => state.displayReducer.HeaderFontSize);
    const dispatch = useDispatch()

    return(
        <Modal
            visible={props.Visible}
            width="500px"
            footer={null}
            className="admin-user-details-modal"
            onCancel={props.CloseModal}
        >
            <br/>
            <label>Content Font</label>
            <Input
                type={'number'}
                min={12}
                max={1000}
                step={1}
                value={contentFontSize}
                onChange={(event: any) => dispatch({
                    type: CHANGE_CONTENT_FONT,
                    payload: {
                        fontSize: parseInt(event.target.value)
                    }
                })}
            />

            <br/>
            <br/>
            <label>Header Font</label>
            <Input
                type={'number'}
                min={12}
                max={1000}
                step={1}
                value={headerFontSize}
                onChange={(event: any) => dispatch({
                    type: CHANGE_HEADER_FONT,
                    payload: {
                        fontSize: parseInt(event.target.value)
                    }
                })}
            />
        </Modal>
    )
}